import _ from 'lodash';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useFetch from '~/view-data/use-fetch';
import useGlobalContext from '~/view-data/use-global-context';
import useHeader from '~/view-data/use-header';

const initialState = {
  loading: false,
  data: [],
};

const useDashboardSupplier = () => {
  const history = useHistory(),
    { state: { dashboardSupplier = initialState } } = useGlobalContext(),
    { state: headerState, actions: headerActions } = useHeader();

  useEffect(() => {
    headerActions.configure({
      useFilter: false,
      title: 'Dashboard',
      count: 'none',
      onSearch: null,
      loading: dashboardSupplier.loading
    });
    // eslint-disable-next-line
  }, [dashboardSupplier.loading, headerState.filter.data]);

  const { data } = useFetch({ url: 'dashboard-supplier/load' });

  const goToPersons = () => {
    history.push('/persons');
  };

  const goToEvents = () => {
    history.push('/events');
  };

  const goToAccreditation = (row) => {
    history.push(`/events/accredit/${_.get(row, 'event.id')}`);
  };

  return {
    state: {
      ...dashboardSupplier,
      loading: !data,
      data: data || {},
    },
    actions: {
      goToEvents,
      goToPersons,
      goToAccreditation,
    },
  };
};

export default useDashboardSupplier;
